export default __webpack_public_path__ + "static/media/025-slot machine.6b8ebc3a.svg";